module.exports = __webpack_public_path__ + "img/loading-mini.9b958b38.gif";